import React, { useState, useEffect } from 'react';

const DietaryRecallTable = ({ patientId }) => {
  const [mealEntries, setMealEntries] = useState([]);
  const [newEntry, setNewEntry] = useState({
    mealTime: '',
    time: '',
    dishName: '',
    description: '',
  });

  useEffect(() => {
    fetchDietaryRecalls();
  }, [patientId]);

  const fetchDietaryRecalls = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/dietary-recalls/${patientId}/`
      );
      if (response.ok) {
        const data = await response.json();
        setMealEntries(data);
      }
    } catch (error) {
      console.error('Error fetching dietary recalls:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewEntry((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddEntry = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/dietary-recalls/${patientId}/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(newEntry),
        }
      );

      if (response.ok) {
        setNewEntry({ mealTime: '', time: '', dishName: '', description: '' });
        fetchDietaryRecalls(); // Refresh entries
      }
    } catch (error) {
      console.error('Error adding dietary recall:', error);
    }
  };

  return (
    <div className="sc alg bg-gray-50 p-4 rounded-lg">
      <h2 className="text-xl font-bold mb-4">Manual Dietary Recall Entry</h2>

      {/* Input Form */}
      <form onSubmit={handleAddEntry} className="grid grid-cols-4 gap-4 mb-6">
        <input
          name="mealTime"
          type="text"
          placeholder="Meal Time (e.g. Breakfast)"
          value={newEntry.mealTime}
          onChange={handleChange}
          className="p-2 border rounded"
          required
        />
        <input
          name="time"
          type="time"
          value={newEntry.time}
          onChange={handleChange}
          className="p-2 border rounded"
          required
        />
        <input
          name="dishName"
          type="text"
          placeholder="Dish Name"
          value={newEntry.dishName}
          onChange={handleChange}
          className="p-2 border rounded"
          required
        />
        <input
          name="description"
          type="text"
          placeholder="Description"
          value={newEntry.description}
          onChange={handleChange}
          className="p-2 border rounded"
          required
        />
        <button
          type="submit"
          className="col-span-4 bg-pink-500 text-white py-2 rounded hover:bg-pink-600"
        >
          Add Entry
        </button>
      </form>

      {/* Table Display */}
      <div className="overflow-x-auto">
        <table className="w-full text-left border">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2">Meal Time</th>
              <th className="px-4 py-2">Time</th>
              <th className="px-4 py-2">Dish Name</th>
              <th className="px-4 py-2">Description</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {mealEntries.map((entry) => (
              <tr key={entry.id} className="border-t">
                <td className="px-4 py-2">{entry.mealTime}</td>
                <td className="px-4 py-2">{entry.time}</td>
                <td className="px-4 py-2">{entry.dishName}</td>
                <td className="px-4 py-2">{entry.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DietaryRecallTable;

